import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UTILS, INS } from "../config/API"
const AccountRequest = () => {
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const US_STATES = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
    "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
    "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
    "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
    "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ];

  // useEffect(() => {
  //   const fetchFormFields = async () => {
  //     try {
  //       const response = await fetch(UTILS, {
  //         method: "POST",
  //         headers: { 
  //           "Content-Type": "application/x-www-form-urlencoded",
  //           "Accept": "application/json" // Explicitly request JSON
  //         },
  //         body: new URLSearchParams({
  //           action: "desc",
  //           itype: "contractor",
  //           stype: "accountrequest"
  //         }),
  //       });

  //       const data = await response.json();

  //       if (response.ok) {
  //         if (Array.isArray(data)) {
  //           setFormFields(
  //             data.filter(field => !["itemid", "autonumber", "readonlydate"].includes(field.fieldtype))
  //               .sort((a, b) => a.sortorder - b.sortorder)
  //           );
  //         } else {
  //           throw new Error("API response is not an array");
  //         }
  //       } else {
  //         throw new Error(data.message || "Failed to fetch form fields");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching form fields:", error);
  //       // Handle error state here if needed
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchFormFields();
  // }, []);


  useEffect(() => {
    const fetchFormFields = async () => {
      try {
        const response = await fetch(UTILS, {
          method: "POST",
          headers: { 
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
          },
          body: new URLSearchParams({
            action: "desc",
            itype: "contractor",
            stype: "accountrequest"
          }),
        });
  
        const data = await response.json();
  
  
        if (response.ok) {
          if (data.Fields && Array.isArray(data.Fields)) {
            setFormFields(
              data.Fields.filter(field => !["itemid", "autonumber", "readonlydate"].includes(field.fieldtype))
                .sort((a, b) => a.sortorder - b.sortorder)
            );
            // You might want to set other properties from the response as well
            // For example:
            // setFileUploadInfo({
            //   enabled: data.FileUpload,
            //   text: data.FileUploadText,
            //   fileTypes: data.FileTypes
            // });
            // setSignatureInfo({
            //   enabled: data.Signature,
            //   text: data.SignatureText
            // });
          } else {
            throw new Error("API response does not contain Fields array");
          }
        } else {
          throw new Error(data.message || "Failed to fetch form fields");
        }
      } catch (error) {
        console.error("Error fetching form fields:", error);
        // Handle error state here if needed
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchFormFields();
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('itype', 'contractor');
    formDataToSend.append('stype', 'accountrequest');
    formDataToSend.append('action', 'ins');

    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        formDataToSend.append(key, formData[key]);
      }
    }

    const fetchUrl = INS;
    fetch(fetchUrl, {
      method: "POST",
      body: formDataToSend,
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.text();
      })
      .then(text => {
        try {
          const data = JSON.parse(text);
          if (data.result === "true") {
            setIsSubmitted(true);
          }
        } catch (e) {
          console.error('Failed to parse JSON:', e);
        }
      })
      .catch(error => {
        console.error("Submission error:", error);
      });
  };



  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFE5E5] to-[#FFF3E0] flex items-center justify-center p-6">
      <div className="w-full max-w-4xl bg-white rounded-xl shadow-xl border border-white/20">
        <div className="bg-[#711515] text-white px-10 py-8 rounded-t-xl shadow-md">
          <h2 className="text-3xl font-bold tracking-wide text-center font-serif">
            {isSubmitted ? "THANK YOU!" : "ACCOUNT REGISTRATION PORTAL"}
          </h2>
        </div>

        <div className="px-10 py-12 space-y-10">
          {isSubmitted ? (
            <div className="text-center space-y-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-20 w-20 text-green-500 mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <h3 className="text-2xl font-semibold text-gray-700">
                We will contact you shortly.
              </h3>
              <p className="text-gray-600">
                Your registration has been successfully submitted.
              </p>
              <button
                onClick={() => navigate("/")}
                className="w-full bg-[#711515] text-white p-5 rounded-xl font-bold text-xl shadow-lg hover:bg-[#5a1010] transition-colors"
              >
                OK
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-8">
              {isLoading ? (
                // Custom Loading Spinner
                <div className="flex flex-col items-center justify-center space-y-4">
                  <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#711515] border-t-transparent"></div>
                  <p className="text-gray-600">Loading form fields...</p>
                </div>
              ) : formFields.length > 0 ? (
                formFields.map((field) => (
                  <div key={field.displayid}>
                    <label className="block text-gray-700 font-semibold mb-3">
                      {field.required === "Y" && <span className="text-[#711515]">*</span>} {field.displayname}
                    </label>
                    {field.fieldtype === "text" ? (
                      <input
                        type="text"
                        name={field.fieldname}
                        value={formData[field.fieldname] || ""}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                        style={{ width: field.fieldlength ? `${field.fieldlength}%` : '100%' }}
                        required={field.required === "Y"}
                        maxLength={field.maxlength || ""}
                      />
                    ) : field.fieldtype === "textarea" ? (
                      <textarea
                        name={field.fieldname}
                        value={formData[field.fieldname] || ""}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                        style={{ width: field.fieldlength ? `${field.fieldlength}%` : '100%' }}
                        required={field.required === "Y"}
                        rows="4"
                      ></textarea>
                    ) : field.fieldtype === "picklist" ? (
                      field.fieldname.toLowerCase() === "state" ? (
                        <select
                          name={field.fieldname}
                          value={formData[field.fieldname] || ""}
                          onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                          className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                          size={field.fieldlength || 1}
                          required={field.required === "Y"}
                        >
                          <option value="">Select {field.displayname}</option>
                          {US_STATES.map((state) => (
                            <option key={state} value={state}>{state}</option>
                          ))}
                        </select>
                      ) : (
                        <select
                          name={field.fieldname}
                          value={formData[field.fieldname] || ""}
                          onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                          className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                          size={field.fieldlength || 1}
                          required={field.required === "Y"}
                        >
                          <option value="">Select {field.displayname}</option>
                          {field.options?.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      )
                    ) : null}
                  </div>
                ))
              ) : (
                <p className="text-gray-500 text-center">No form fields available.</p>
              )}

              <div className="mt-12">
                <button
                  type="submit"
                  className="w-full bg-[#711515] text-white p-5 rounded-xl font-bold text-xl shadow-lg hover:bg-[#5a1010] transition-colors"
                >
                  SUBMIT REGISTRATION
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountRequest;